
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"baguette"}},[_c('rect',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x":"12.35","y":"4","width":"23.29","height":"40"}}),_c('rect',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x":"15.21","y":"6.86","width":"17.58","height":"34.29"}}),_c('rect',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x":"18.07","y":"9.71","width":"11.86","height":"28.57"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"12.35","y1":"4","x2":"24","y2":"15.65"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"35.65","y1":"4","x2":"24","y2":"15.65"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"35.65","y1":"44","x2":"24","y2":"32.35"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"12.35","y1":"44","x2":"24","y2":"32.35"}}),_c('line',{attrs:{"fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"0.5","x1":"24","y1":"15.65","x2":"24","y2":"32.35"}})])])
          )
        }
      }
    